<template>
    <!-- Hero Sections Here -->
    <section class="banner__breadcumn ralt">

        <!--Search Popup-->
        <div id="searchPopup" class="search__popup">
            <form action="#" class="popup-content d-flex align-items-center">
                <input type="text" placeholder="Search Here">
                <button id="closeButton">
                    <i class="bi bi-x-lg"></i>
                </button>
            </form>
        </div>
        <!--Search Popup-->
        <div class="breadcumnd__wrapper">
            <div class="container">
                <div class="profile__wrappers post__requestwrapper pt-100 pb-100">
                    <div class="row g-4 align-items-center justify-content-between">
                        <div class="col-xxl-6 col-xl-6 col-lg-7 col-md-7 col-sm-7">
                            <div class="breadcumnd__content">
                                <span class="d41 mb-24">
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--post request-->
        <div class="overview__showcase ralt">
            <div>
                <div>
                    <div class="container">
                        <div class="overview__showcasewrap1  row justify-content-center  post__requestwrap">
                            <div class="col-lg-8">
                                <div class="contact__wrapper round16 bgwhite">

                                    <div class="center" style="margin-top: -80px;">
                                        <img src="https://new.pochta.uz/media/123.svg" alt="SVG rasm" width="100"
                                            height="100">
                                        <br>
                                        <br>
                                        <br>
                                        <br>
                                        <h3 class="pb-30 mb-30 title2">
                                            Tez orada UzPost mas'ul xodimlari siz bilan bog'lanishlari mumkin.
                                        </h3>
                                        <br>
                                        <h3 class="pb-30 bborderdash mb-30 title2">
                                        </h3>
                                        <br>
                                        <br>
                                        <router-link to="/vakansiyalar" class="cmn--btn outline__btn">
                                            <span>
                                                <i class="fa fa-arrow-left" style="margin-right: 5px;"></i>
                                                Vakansiyalar
                                            </span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <!-- Hero Section End -->
</template>